import { useState } from 'react';

export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: '設置費用はどのくらいかかりますか？',
      answer: '屋根の種類によって工法も違いますので、お見積り前に屋根の寸法、状態等を確認させていただいてからのご提案となります。なおお得な特売品などの情報をブログに載せてある場合がありますので、チェックしてみてください。',
      icon: 'ri-money-dollar-circle-line'
    },
    {
      question: '工事期間はどのくらいですか？',
      answer: '電力会社への申請手続き等がございますので、それを含めた期間はご契約～工事完了まで3～4か月くらいとなります。設置工事自体は通常、1〜2日程度で完了します。天候や屋根の状態により多少前後する場合がありますが、事前に詳しくご説明いたします。',
      icon: 'ri-time-line'
    },
    {
      question: 'アフターサービスが心配ですが？',
      answer: '石川県・富山県の地域密着だからこそ、トラブル時も迅速に対応できます。定期点検やメンテナンスも承っておりますので、長期的に安心してご利用いただけます。',
      icon: 'ri-customer-service-2-line'
    }
  ];

  return (
    <section className="py-16 sm:py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <div className="inline-block bg-purple-100 text-purple-700 px-4 py-2 rounded-full text-sm font-medium mb-4">
            <i className="ri-question-answer-line mr-1"></i>
            よくあるご質問
          </div>
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            お悩み解決Q&amp;A
          </h2>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white rounded-xl shadow-md hover:shadow-lg transition-all duration-300 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between p-6 text-left hover:bg-gray-50 transition-colors duration-200"
              >
                <div className="flex items-start space-x-4 flex-1">
                  <div className="w-10 h-10 flex items-center justify-center bg-emerald-100 rounded-full flex-shrink-0">
                    <i className={`${faq.icon} text-xl text-emerald-600`}></i>
                  </div>
                  <div className="flex-1">
                    <h3 className="font-bold text-gray-900 text-base sm:text-lg pr-4">
                      {faq.question}
                    </h3>
                  </div>
                </div>
                <i className={`ri-arrow-down-s-line text-2xl text-gray-400 transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'transform rotate-180' : ''}`}></i>
              </button>
              
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <div className="px-6 pb-6 pl-20">
                  <p className="text-gray-700 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* まだ不安な方へ */}
        <div className="mt-12 bg-gradient-to-r from-blue-50 to-teal-50 rounded-2xl p-8 text-center border border-blue-100">
          <p className="text-gray-700 mb-6 leading-relaxed">
            どんな小さなことでもお気軽にご相談ください。<br />
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="tel://0762553483"
              className="w-full sm:w-auto bg-emerald-500 hover:bg-emerald-600 text-white px-6 py-3 rounded-lg font-bold transition-all duration-300 shadow-md hover:shadow-lg whitespace-nowrap"
            >
              <i className="ri-phone-fill mr-2"></i>
              電話で質問する
            </a>
            <button
              onClick={() => {
                const contactSection = document.getElementById('contact-section');
                if (contactSection) {
                  contactSection.scrollIntoView({ behavior: 'smooth' });
                }
              }}
              className="w-full sm:w-auto bg-white hover:bg-gray-50 text-emerald-600 px-6 py-3 rounded-lg font-bold transition-all duration-300 shadow-md hover:shadow-lg border-2 border-emerald-500 whitespace-nowrap"
            >
              <i className="ri-mail-line mr-2"></i>
              フォームで質問する
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
